import { WireTypes } from "../wireTypes.js";

export type ExtractorType = 'test' | 'error' | 'status' | 'tag' | 'testline' | 'annotation' | 'testduration' | 'fliprate' | 'failrate';

export class Extractor<FROM, TO> {
  static TAG = new Extractor<string, string>('tag', tag => [tag]);
  static TEST_TEXT_PARTS = new Extractor<WireTypes.Test, string>('test', test => [test.filePath, ...test.titles].filter(x => x !== undefined));
  static TEST_FILE = new Extractor<WireTypes.Test, string>('test', test => [test.filePath].filter(x => x !== undefined));
  static TEST_ID = new Extractor<WireTypes.Test, string>('test', test => [test.testId]);
  static TEST_LINE = new Extractor<number, number>('testline', lineNumber => [lineNumber]);
  static TEST_DURATION = new Extractor<number, number>('testduration', durationMs => [durationMs]);
  static FLIP_RATE = new Extractor<number, number>('fliprate', flipRate => [flipRate]);
  static FAIL_RATE = new Extractor<number, number>('failrate', failRate => [failRate]);
  static STATUS = new Extractor<WireTypes.Outcome, string>('status', e => [outcomeToStatusFilter(e)]);
  static ERROR_TEXT = new Extractor<WireTypes.TestError, string>('error', error => [error.message, error.value].filter(x => x !== undefined));
  static ANNOTATION_PARTS = new Extractor<WireTypes.Annotation, string>('annotation', annotation => [annotation.type, annotation.description].filter(x => x !== undefined));

  constructor(
    readonly type: ExtractorType,
    readonly extract: (element: FROM) => TO[]) {
  }
}

export function outcomeToStatusFilter(outcome: WireTypes.Outcome): string {
  if (outcome === 'regressed')
    return 'regressed';
  if (outcome === 'unexpected')
    return 'failed';
  if (outcome === 'flaked')
    return 'flaked';
  if (outcome === 'expected')
    return 'passed';
  if (outcome === 'skipped')
    return 'skipped';
  throw new Error(`Unknown outcome - "${outcome}"`)
}